import Web3 from 'web3'

if (typeof web3 !== 'undefined') {
  // If a web3 instance is already provided by Meta Mask.
  // Metamask turns Chrome browser into a BC browser, that
  // can connect to the Ethereum network.
  // When we login to Metamask, it provides us with a web3 provider
  // then we set this metamask web3 provider to the app web3 provider
  var web3Provider = web3.currentProvider
  console.log('Web3 injected browser: OK - MetaMask is enabled')
} else {
  // Specify default instance if no web3 instance provided
  // = Default web3 provider from the local BC instance
  var web3Provider = new Web3.providers.HttpProvider('http://localhost:7545')
  console.log('Web3 injected browser: OK - MetaMask is missing, defaulting to Http. You should consider trying MetaMask.')
}

var web3Instance = new Web3(web3Provider);

export default web3Instance


// WEBPACK FOOTER //
// ./src/utils/web3Instance.js